import React from "react";
import GroupReaders from "./GroupReaders";
import GroupModerators from "./GroupModerators";

const GroupModeratorsAndReaders = ({
  match,
  canManageGroup,
  selectedGroup,
  isReplicaGroup,
}) => {
  const canModifyGroup =
    canManageGroup && !isReplicaGroup && selectedGroup.syncType !== "SyncError";

  return (
    <>
      <GroupModerators match={match} canManageGroup={canModifyGroup} />
      <GroupReaders match={match} canManageGroup={canModifyGroup} />
    </>
  );
};

export default GroupModeratorsAndReaders;
